import ApiService from "../../common/api.service";
import Vue from "vue";

const state = {
  all: [],
  cache: {}
};

// getters
const getters = {
  getById: state => id => {
    return state.all[state.cache[id]];
  },
  getAll: state => {
    return state.all;
  }
};

// actions
const actions = {
  add(context, item) {
    return new Promise((resolve, reject) => {
      ApiService.post("/waitinglist", item)
        .then(response => {
          context.commit("ADD", response.data);
          resolve(response);
        })
        .catch(error => {
          reject(error);
        });
    });
  },
  update(context, item) {
    return new Promise((resolve, reject) => {
      ApiService.put("/waitinglist/" + item.id, item)
        .then(response => {
          context.commit("UPDATE", response.data);
          resolve(response);
        })
        .catch(error => {
          reject(error);
        });
    });
  },
  delete(context, item) {
    return new Promise((resolve, reject) => {
      ApiService.delete("/waitinglist/" + item.id, item)
        .then(() => {
          context.commit("DEL", item);
          resolve();
        })
        .catch(error => {
          reject(error);
        });
    });
  },
  getAll(context) {
    ApiService.get("/waitinglist").then(response => {
      context.commit("SET", response.data);
    });
  }
};

// mutations
const mutations = {
  ADD(state, item) {
    state.all.push(item);
    state.cache[item.id] = state.all.length - 1;
  },
  SET(state, items) {
    state.all = items;
    createCache(items);
  },
  UPDATE(state, item) {
    const index = state.cache[item.id];
    Vue.set(state.all, index, item);
  },
  DEL(state, item) {
    state.all.splice(state.cache[item.id], 1);
  }
};

function createCache(items) {
  for (let i = 0; i < items.length; i++) {
    state.cache[items[i].id] = i;
  }
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
};
